module.exports = __webpack_public_path__ + "img/rights@2x.b705dc0.jpg";